// @ts-ignore
import * as Mixpanel from "mixpanel-browser";
import { IApplication } from "shared/model/IApplication";

import { IUserAuthData } from "../../state/modules/auth/auth";
import Config from "../Config/Config";
import RavenService from "../Logging/RavenService";
import { AnalyticsEvent } from "./AnalyticsConstants";
import {AnalyticsSignUpEvents} from "./AnalyticsSignUpEvents";
import {AnalyticsAccountEvents} from "./AnalyticsAccountEvents";

type AnalyticsProps = { [key: string]: string | number };

Mixpanel.init(Config.mixpanelToken());
const shouldTrackAnalytics = Config.shouldTrackAnalytics();

export default class MixPanelAnalyticsService {
  public static track(event: AnalyticsEvent | AnalyticsSignUpEvents | AnalyticsAccountEvents, params?: any) {
    if (shouldTrackAnalytics) {
        Mixpanel.track(event, params);
    }
  }

  public static trackPageView(page: string, props: AnalyticsProps = {}) {
    MixPanelAnalyticsService.track(AnalyticsEvent.PageView, { page, ...props });
  }

  public static trackError(props: AnalyticsProps) {
    MixPanelAnalyticsService.track(AnalyticsEvent.Error, props);
    RavenService.captureMessage(`Error - ${JSON.stringify(props)}`);
  }

  public static trackDepositCollectorSuccess(
    isACH: boolean,
    isCredit: boolean,
    isSalaryo: boolean,
    financingPaymentAmount: number,
    application: IApplication
  ) {
    MixPanelAnalyticsService.track(AnalyticsEvent.DepositCollectorSuccess, {
      isACH,
      isCredit,
      isSalaryo,
      financingPaymentAmount,
      depositAmount: application.amount,
      memberEmail: application.applicantEmail,
      coworkName: application.coworkDisplayName,
      branchName: application.branchDisplayName
    });
  }

  public static trackApplicationCreated(application: IApplication) {
    if (!shouldTrackAnalytics) {
      return;
    }

    MixPanelAnalyticsService.track(
      AnalyticsEvent.ApplicationCreation,
      MixPanelAnalyticsService.applicationProps(application)
    );
    Mixpanel.people.increment("applicationsCreated");
  }

  public static registerUser(user?: IUserAuthData) {
    if (!shouldTrackAnalytics) {
      return;
    }

    if (user) {
      Mixpanel.identify(user.uid);

      const data = {
        $email: user.email,
        displayName: user.displayName
      };

      Mixpanel.people.set(data);
      Mixpanel.register(data);
    }
  }

  public static applicationProps(application: IApplication) {
    return {
      id: application.uid || "NA",
      cowork: application.coworkDisplayName,
      branch: application.branchDisplayName,
      memberEmail: application.applicantEmail,
      depositAmount: application.amount
    };
  }


}



// WEBPACK FOOTER //
// ./src/services/Analytics/MixPanelAnalyticsService.ts